import { Pipe, PipeTransform } from "@angular/core";
import { Items } from "../../../mediator-commlibs/interfaces/response/menu.interface";
@Pipe({
  name: "upsellingCount",
})
export class UpsellingCount implements PipeTransform {
  transform(menu: Items[]): number {
    return [...(menu || [])].filter(item => !item['isDeleted']).length;
  }
}